import React, { useEffect, useMemo, useState } from 'react'
import {
  HighestRatedContainer,
  ErrorMessage,
  BusinessList,
  Title,
  BusinessListWrapper,
  Description
} from './styles'

import { useLanguage, useOrder, BusinessList as BusinessListController } from '~components'

import {
  AutoScroll,
  Modal,
  getCateringValues,
  Button,
  BusinessPreorder,
  BusinessController,
  NotFoundSource
} from '~ui'

const HighestRatedUI = (props) => {
  const {
    scrollId,
    businessesList,
    handleBusinessClick,
    isCustomLayout,
    handleClickAddress,
    setHasHighRatedBusiness,
    isCustomerMode,
    favoriteIds,
    setFavoriteIds,
    businessUrlTemplate,
    title,
    description,
    setHasFeaturedBusinesses
  } = props

  const [, t] = useLanguage()
  const [orderState] = useOrder()
  const [isPreorder, setIsPreorder] = useState(false)
  const [preorderBusiness, setPreorderBusiness] = useState(null)

  const isBusinessWithReviews = businessesList?.businesses?.every((business) => business?.reviews?.total === 0)
  const cateringTypeString = orderState?.options?.type === 7
    ? 'catering_delivery'
    : orderState?.options?.type === 8
      ? 'catering_pickup'
      : null
  const cateringValues = preorderBusiness?.configs && getCateringValues(cateringTypeString, preorderBusiness?.configs)

  const handleClosePreorder = () => {
    setIsPreorder(false)
    setPreorderBusiness(null)
  }

  useEffect(() => {
    if (preorderBusiness) setIsPreorder(true)
  }, [preorderBusiness])

  useEffect(() => {
    if (!businessesList.loading) {
      setHasHighRatedBusiness && setHasHighRatedBusiness(!isBusinessWithReviews)
      setHasFeaturedBusinesses && setHasFeaturedBusinesses(businessesList?.businesses?.length > 0)
    }
  }, [businessesList?.businesses])

  useEffect(() => {
    if (!businessesList?.businesses?.length) return
    const ids = [...(favoriteIds ?? [])]
    businessesList.businesses.forEach(business => {
      if (business?.favorite) {
        ids.push(business.id)
      }
    })
    setFavoriteIds && setFavoriteIds([...new Set(ids)])
  }, [businessesList?.businesses?.length])

  const businesslist = useMemo(() => businessesList?.businesses?.filter((business) => business?.reviews?.total > 0 || scrollId), [businessesList?.businesses, scrollId])

  return (
    <>
      <HighestRatedContainer>
        <Title>{title ?? t('EVERYONES_FAVORITE', 'Everyone\'s favorite')}</Title>
        {description && <Description>{description}</Description>}
        <BusinessListWrapper>
          <BusinessList id={scrollId ?? 'highestRated'}>
            {
              handleClickAddress && !isCustomerMode && !businessesList.loading && (businessesList.businesses.length === 0 || (isBusinessWithReviews && !scrollId)) && (
                <NotFoundSource
                  content={t('NOT_FOUND_BUSINESSES_HIGHEST_RATED', 'No highest rated businesses found, please change filters or change address.')}
                >
                  <Button
                    outline
                    color='primary'
                    onClick={() => handleClickAddress()}
                  >
                    {t('CHANGE_ADDRESS', 'Select other Address')}
                  </Button>
                </NotFoundSource>
              )
            }
            <AutoScroll scrollId={scrollId ?? 'highestRated'}>
              {
                !businessesList?.loading && businesslist?.map((business, index) => (
                    <BusinessController
                      key={business.id}
                      className='card'
                      business={business}
                      isBusinessOpen={business.open && business?.enabled !== false}
                      handleCustomClick={handleBusinessClick}
                      orderType={orderState?.options?.type}
                      isCustomLayout={isCustomLayout}
                      isCustomerMode={isCustomerMode}
                      favoriteIds={favoriteIds}
                      setFavoriteIds={setFavoriteIds}
                      onPreorderBusiness={setPreorderBusiness}
                      businessUrlTemplate={businessUrlTemplate}
                      m={index === businesslist?.length - 1 ? '10px 0px 10px 20px' : '10px 20px'}
                    />
                ))
              }
            </AutoScroll>
            {businessesList.loading && (
              [...Array(8).keys()].map(i => (
                <BusinessController
                  key={i}
                  className='card'
                  business={{}}
                  isSkeleton
                  orderType={orderState?.options?.type}
                />
              ))
            )}
            {businessesList.error && businessesList.error.length > 0 && businessesList.businesses.length === 0 && (
              businessesList.error.map((e, i) => (
                <ErrorMessage key={i}>{t('ERROR', 'ERROR')}: [{e?.message || e}]</ErrorMessage>
              ))
            )}
          </BusinessList>
        </BusinessListWrapper>
      </HighestRatedContainer>
      {isPreorder && (
        <Modal
          open={isPreorder}
          width='760px'
          onClose={() => handleClosePreorder()}
        >
          <BusinessPreorder
            business={preorderBusiness}
            handleClick={handleBusinessClick}
            showButton
            cateringPreorder={!!cateringTypeString}
            {...cateringValues}
          />
        </Modal>
      )}
    </>
  )
}

export const HighestRated = (props) => {
  const highestRatedProps = {
    ...props,
    UIComponent: HighestRatedUI,
    avoidRefreshUserInfo: true
  }
  return <BusinessListController {...highestRatedProps} />
}
